var _defs, _path, _path2, _rect, _rect2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddPersonBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.99 95.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3c444c;stroke:#3c444c;stroke-miterlimit:10;stroke-width:0.25px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.16,48.4A10.41,10.41,0,1,1,64.57,38,10.41,10.41,0,0,1,54.16,48.4Zm0-20A9.61,9.61,0,1,0,63.77,38,9.62,9.62,0,0,0,54.16,28.39Z",
    transform: "translate(-0.01 -0.01)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.57,68.41H33.75V63c0-6.83,13.29-10.4,20.41-10.4S74.57,56.18,74.57,63Zm-40-.79H73.78V63c0-6.21-13-9.61-19.62-9.61S34.55,56.8,34.55,63Z",
    transform: "translate(-0.01 -0.01)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.74,
    y: 35.49,
    width: 0.8,
    height: 20.01
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.13,
    y: 45.09,
    width: 20.01,
    height: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48,95.87A47.87,47.87,0,1,1,95.87,48,47.92,47.92,0,0,1,48,95.87ZM48,.93A47.07,47.07,0,1,0,95.07,48,47.13,47.13,0,0,0,48,.93Z",
    transform: "translate(-0.01 -0.01)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPersonBlack);
export default __webpack_public_path__ + "static/media/add_person_black.0851830df1ce0b5fbbb5009f06de5769.svg";
export { ForwardRef as ReactComponent };